import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { API_ENDPOINTS } from '../../../../../shared/utils/const';
import { ApiService } from '../../../../../shared/services/api.service';
import { DatePipe } from '@angular/common';
import { CommonService } from '../../../../../shared/services/common.service';
import { ToastrService } from 'ngx-toastr';
import { param } from 'jquery';
//import { dE } from '@fullcalendar/core/internal-common';
import { Location } from '@angular/common';

@Component({
  selector: 'app-eventreport',
  templateUrl: './eventreport.component.html',
  styleUrl: './eventreport.component.css'
})
export class EventreportComponent implements OnInit {

  eventReportForm: FormGroup;
  isSubmitted = false;
  UserUniqueId: any=null;
  UniqueEventId: any;
  startDateTime: Date | null = null;
  timeValue: string | null = null; // To hold raw time value
  formattedTime: string | null = null; // To hold formatted time value
  selectedTabIndex: number = 0;  // Initially, the first tab is active
  isHidden = false;
  actualDate: any;
  DateCompletionTime: Date | null = null;
  startTime: any;
  endTime: any;
  formattedDate: any;
  spocList: any;

  amenities = ['Air conditioned', 'Hall', 'Breakfast', 'Lunch', 'High tea', 'Tea', 'Dinner', 'Accommodation', 'Air conditioned accommodation'];

  constructor(
    private datePipe: DatePipe,
    private apiService: ApiService,
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private commonService: CommonService,
    private toastrService: ToastrService,
    private location: Location
  ) {
    // Create a reactive form group with form controls
    this.eventReportForm = new FormGroup({
      nameOfOrganisation: new FormControl({ value: '', disabled: true }),
      interventionName: new FormControl({ value: '', disabled: true }),
      interestName: new FormControl({ value: '', disabled: true }),
      eventName: new FormControl({ value: '', disabled: true }),
      trainerCompanyName: new FormControl({ value: '', disabled: true }),
      bWorkshop: new FormControl('', [Validators.required, Validators.maxLength(100)]),//, Validators.pattern(this.commonService.stringWithSpaceAtmiddlePattern)]),
      eventDate: new FormControl({ value: '', disabled: true }),//[Validators.required]
      actualStartDate: new FormControl('', [Validators.required]),
      actualStartTime: new FormControl('', [Validators.required]),
      dateOfCompletion: new FormControl('', [Validators.required]),
      timeOfCompletion: new FormControl('', [Validators.required]),
      /*durationOfWorkshop: new FormControl('', [Validators.required, Validators.pattern(this.commonService.decimalNumberPatter)]),*/
      durationOfWorkshop: new FormControl({ value: '', disabled: true }),
      //unit: new FormControl([value: '', disabled: true], '', [Validators.required]),
      unit: new FormControl({ value: '', disabled: true }, Validators.required),
      contactNumber: new FormControl({ value: '', disabled: true }),
      trainerEmailId: new FormControl('', [Validators.pattern(this.commonService.emailPattern)]),

      numberOfParticipants: new FormControl({ value: '', disabled: true }),
      numberOfUniqueParticipants: new FormControl({ value: '', disabled: true }),

      numberOfWomenParticipants: new FormControl({ value: '', disabled: true }),
      numberOfSC: new FormControl({ value: '', disabled: true }),
      numberOfST: new FormControl({ value: '', disabled: true }),
      numberOfMicroEnterprises: new FormControl({ value: '', disabled: true }),
      numberOfSmallEnterprises: new FormControl({ value: '', disabled: true }),
      numberOfMediumEnterprises: new FormControl({ value: '', disabled: true }),

      districtName: new FormControl({ value: '', disabled: true }),
      blockName: new FormControl({ value: '', disabled: true }),
      village: new FormControl({ value: '', disabled: true }),
      venueDetails: new FormControl({ value: '', disabled: true }),
      amenities: new FormControl(''),
      spocName: new FormControl({ value: '', disabled: true }),
      spocMobile: new FormControl({ value: '', disabled: true }),
      spocEmail: new FormControl('', [Validators.pattern(this.commonService.emailPattern)]),
      highlightsWorkshop: new FormControl('', [Validators.maxLength(1500)]),// Validators.pattern(this.commonService.stringWithSpaceAtmiddlePattern)]),
      handholdingWorkshop: new FormControl('', [Validators.maxLength(1500)]),// Validators.pattern(this.commonService.stringWithSpaceAtmiddlePattern)]),
    });


  }

  get f() { return this.eventReportForm.controls }

  units = ['Day', 'Hours'];

  ngOnInit() {
    this.loadData();

    this.eventReportForm.get('durationOfWorkshop')?.disable();

    this.eventReportForm.get('actualStartTime')?.valueChanges.subscribe((value) => {
      this.onTimeChange(value, 'startTime');
    });

    this.eventReportForm.get('timeOfCompletion')?.valueChanges.subscribe((value) => {
      this.onTimeChange(value, 'endTime');
    });

  }

  async loadData() {
    this.route.params.subscribe(params => {
      this.UniqueEventId = params['eventid'];
      this.UserUniqueId = params['iaid'] || '';
    });

    let data: any = { UniqueEventId: this.UniqueEventId };

    if (this.UserUniqueId) {
      data.UserUniqueId = this.UserUniqueId;
    }
    this.apiService.getRequest(API_ENDPOINTS.IA.GETEVENTOUTPUTREPORT, data).subscribe(
      (result: any) => {
        
        this.spocList = result.data.item2;
        var actualStartDate;
        var dateOfCompletion;
        if (result.data.item1[0].actualStartDate)
          actualStartDate = this.convertStringToDate(result.data.item1[0].actualStartDate);
        if (result.data.item1[0].dateOfCompletion)
          dateOfCompletion = this.convertStringToDate(result.data.item1[0].dateOfCompletion);

        var timeDiff;
        if (result.data.item1[0].actualStartDate != null && result.data.item1[0].dateOfCompletion != null) {
          var unit1 = this.isSameDate(result.data.item1[0].actualStartDate, result.data.item1[0].dateOfCompletion)
          var unit;
          if (unit1)
            unit = "Day";
          else
            unit = "Hours";
          
          timeDiff = this.calculateTimeDifference(result.data.item1[0].actualStartTime, result.data.item1[0].timeOfCompletion);
          
        }
        
        var date = new Date(this.convertToFormattedDate(result.data.item1[0].eventDate))
        this.actualDate = date;

        this.eventReportForm.patchValue({
          nameOfOrganisation: result.data.item1[0].nameOfOrganisation,
          interventionName: result.data.item1[0].interventionName,
          interestName: result.data.item1[0].interestName,
          eventName: result.data.item1[0].eventName,
          trainerCompanyName: result.data.item1[0].trainerCompanyName,
          bWorkshop: result.data.item1[0].bWorkshop,
          eventDate: result.data.item1[0].eventDate,
          actualStartDate: actualStartDate,
          actualStartTime: result.data.item1[0].actualStartTime,
          dateOfCompletion: dateOfCompletion,
          timeOfCompletion: result.data.item1[0].timeOfCompletion,
          durationOfWorkshop: timeDiff,//result.data?.durationOfWorkshop,
          unit: unit,//result.data?.unit,
          contactNumber: result.data.item1[0].contactNumber,
          trainerEmailId: result.data.item1[0].trainerEmailId,
          numberOfParticipants: result.data.item1[0].numberOfParticipants,
          numberOfUniqueParticipants: result.data.item1[0].numberOfUniqueParticipants,

          numberOfWomenParticipants: result.data.item1[0].numberOfWomenParticipants,
          numberOfSC: result.data.item1[0].numberOfSC,
          numberOfST: result.data.item1[0].numberOfST,
          numberOfMicroEnterprises: result.data.item1[0].numberOfMicroEnterprises,
          numberOfSmallEnterprises: result.data.item1[0].numberOfSmallEnterprises,
          numberOfMediumEnterprises: result.data.item1[0].numberOfMediumEnterprises,

          districtName: result.data.item1[0].districtName,
          blockName: result.data.item1[0].blockName,
          village: result.data.item1[0].village,
          venueDetails: result.data.item1[0].venueDetails,
          //spocName: result.data?.spocName,
          //spocMobile: result.data?.spocMobile,
          //spocEmail: result.data?.spocEmail,
          highlightsWorkshop: result.data.item1[0].highlightsWorkshop,
          handholdingWorkshop: result.data.item1[0].handholdingWorkshop,
        });


        const str = result.data.item1[0]?.amenities;
        var array;
        if (str) {
          array = str.split(', ').map((item: any) => item.trim());
          this.eventReportForm.get('amenities')?.patchValue(array);
        }

        if (result.data.item1[0]?.status) {
          // Disables all form controls
          this.eventReportForm.disable();
          this.isHidden = true;
        }

      },
      error => {
        console.error('Error fetching data:', error);
      }
    );



  }

  convertToFormattedDate(inputDate: string): string {
    // Split the date string in dd/MM/yyyy format
    const dateParts = inputDate.split('/');

    // Ensure that parts are correctly converted to numbers before passing to the Date constructor
    const day = +dateParts[0];    // Using + operator to convert to number
    const month = +dateParts[1] - 1; // Month is 0-indexed in JavaScript, so subtract 1
    const year = +dateParts[2];   // Convert to number

    // Create a Date object from the split parts (Year, Month, Day)
    const dateObj = new Date(year, month, day);

    // Use Angular's DatePipe to format the date
    const datePipe = new DatePipe('en-US');
    const formattedDate = datePipe.transform(dateObj, 'EEE MMM dd yyyy HH:mm:ss');

    // Append the GMT+0530 timezone offset
    return `${formattedDate} GMT+0530`;
  }

  isSameDate(date1: string | Date, date2: string | Date): boolean {
    const d1 = new Date(date1);
    const d2 = new Date(date2);

    return (
      d1.getFullYear() === d2.getFullYear() &&
      d1.getMonth() === d2.getMonth() &&
      d1.getDate() === d2.getDate()
    );
  }

  calculateTimeDifference(startTime: string, endTime: string): string {
    const start = new Date(`1970-01-01T${this.convertTo24HourFormat(startTime)}:00`);
    const end = new Date(`1970-01-01T${this.convertTo24HourFormat(endTime)}:00`);

    const diffMs = end.getTime() - start.getTime(); // Difference in milliseconds
    const diffHours = Math.floor(diffMs / (1000 * 60 * 60)); // Convert to hours
    const diffMinutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60)); // Get remaining minutes
    //return `${diffHours} hours, ${diffMinutes} minutes`;
    return `${diffHours}.${diffMinutes}`;
  }

  // Convert 12-hour format (AM/PM) to 24-hour format
  convertTo24HourFormat(time: string): string {
    const [timePart, modifier] = time.split(" ");
    let [hours, minutes] = timePart.split(":").map(Number);

    if (modifier === "PM" && hours !== 12) {
      hours += 12;
    } else if (modifier === "AM" && hours === 12) {
      hours = 0;
    }

    return `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}`;
  }

  // This method is called when the Actual Start Date changes
  onDateChange(event: any, action: string): void {
    
    if (action == "dateOfStart")
      this.DateCompletionTime = new Date(event.value);

    if (this.eventReportForm.get('actualStartDate')?.value != null && this.eventReportForm.get('dateOfCompletion')?.value != null) {
      var isUnit = this.isSameDate(this.eventReportForm.get('actualStartDate')?.value, this.eventReportForm.get('dateOfCompletion')?.value);
      if (isUnit)
        this.eventReportForm.patchValue({ unit: 'Hours' });
      else
        this.eventReportForm.patchValue({ unit: 'Day' });
    }

    if (this.startTime != "" && this.endTime != "") {
      this.isStartTimeGreaterThanEndTime(this.startTime, this.endTime);
    }

  }

  // Helper method to convert 'dd/MM/yyyy' string to Date object
  convertStringToDate(dateString: string): Date {
    const parts = dateString?.split('/');
    const day = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10) - 1; // Month is 0-based in JavaScript
    const year = parseInt(parts[2], 10);

    return new Date(year, month, day);
  }

  // Handle form submission
  onSubmit(action: boolean) {

    this.isSubmitted = true;

    var fds = this.eventReportForm.get('actualStartDate')?.value

    if (this.eventReportForm.invalid) {

      // Check for specific form control errors and activate the corresponding tab
      if (this.eventReportForm.get('bWorkshop')?.invalid || this.eventReportForm.get('actualStartDate')?.invalid ||
        this.eventReportForm.get('actualStartTime')?.invalid || this.eventReportForm.get('dateOfCompletion')?.invalid ||
        this.eventReportForm.get('timeOfCompletion')?.invalid || this.eventReportForm.get('durationOfWorkshop')?.invalid ||
        this.eventReportForm.get('unit')?.invalid) {
        this.selectedTabIndex = 0;  // Go to "Event Details" tab
      } else if (this.eventReportForm.get('trainerEmailId')?.invalid) {
        this.selectedTabIndex = 3;  // Go to the "Venue Details" tab (for example)
      }
    } else {
      // Enable fields and set values
      this.eventReportForm.get('unit')?.enable();
      this.eventReportForm.get('durationOfWorkshop')?.enable();
      var data = {
        uniqueEventId: this.UniqueEventId,
        BWorkshop: this.eventReportForm.get('bWorkshop')?.value,
        ActualStartDate: this.datePipe.transform(this.eventReportForm.get('actualStartDate')?.value || 'yyyy-MM-dd'),
        ActualStartTime: this.eventReportForm.get('actualStartTime')?.value,
        DateOfCompletion: this.datePipe.transform(this.eventReportForm.get('dateOfCompletion')?.value || 'yyyy-MM-dd'),
        TimeOfCompletion: this.eventReportForm.get('timeOfCompletion')?.value,
        DurationOfWorkshop: this.eventReportForm.get('durationOfWorkshop')?.value.toString(),
        Unit: this.eventReportForm.get('unit')?.value,
        TrainerEmailId: this.eventReportForm.get('trainerEmailId')?.value,
        Amenities: this.eventReportForm.get('amenities')?.value.join(', '),
        SpocEmail: this.eventReportForm.get('spocEmail')?.value,
        HighlightsWorkshop: this.eventReportForm.get('highlightsWorkshop')?.value,
        HandholdingWorkshop: this.eventReportForm.get('handholdingWorkshop')?.value,
        Status: action,
      }
      this.apiService.postRequest(API_ENDPOINTS.IA.POSTEVENTOUTPUTREPORT, data).subscribe(
        (result: any) => {
          this.toastrService.success('Event Output Report Details added successfully!');
          this.router.navigate(['/view_event']);
        },
        error => {
          this.toastrService.error(error, 'Information cannot be saved. Please check for errors indicated in red.');
        }
      );

    }
  }

  // Method to handle tab change
  onTabChange(event: any) {
    this.selectedTabIndex = event.index;
  }

  onTimeChange(event: any, type: string) {
    if (!event) return; // Ensure the event is valid
    
    const time = event; // Selected time from timepicker
    
    if (type === 'startTime') {
      this.startTime = time;
    } else if (type === 'endTime') {
      this.endTime = time;
    }

    // Ensure both times are selected before comparing
    if (this.startTime && this.endTime) {
      if (this.isStartTimeGreaterThanEndTime(this.startTime, this.endTime)) {
        alert("Start time should not be greater than End time!");
        this.endTime = null; // Reset end time
        this.eventReportForm.get('timeOfCompletion')?.reset(); // Clear form field if using a form
      }
    }
  }

  // Helper function to compare times
  isStartTimeGreaterThanEndTime(startTime: string, endTime: string): boolean {
    const start = this.convertTo24HourFormat(startTime);
    const end = this.convertTo24HourFormat(endTime);
    
    var timeDiff = this.calculateTimeDifference(startTime, endTime)

    if ((this.eventReportForm.get('actualStartDate')?.value != "" && this.eventReportForm.get('actualStartDate')?.value != undefined) && (this.eventReportForm.get('dateOfCompletion')?.value != "" && this.eventReportForm.get('dateOfCompletion')?.value != undefined)) {
      var isUnit = this.isSameDate(this.eventReportForm.get('actualStartDate')?.value, this.eventReportForm.get('dateOfCompletion')?.value);
      if (!isUnit) {
        var diffDay = this.getDateDifference(this.eventReportForm.get('actualStartDate')?.value, this.eventReportForm.get('dateOfCompletion')?.value)
        this.eventReportForm.get('durationOfWorkshop')?.setValue(diffDay);
      }
      else
        this.eventReportForm.get('durationOfWorkshop')?.setValue(timeDiff);
    }else
      this.eventReportForm.get('durationOfWorkshop')?.setValue(timeDiff);
    
    return start >= end;
  }

  getDateDifference(startDate: string | Date, endDate: string | Date): number {
    const start = new Date(startDate);
    const end = new Date(endDate);

    // Calculate difference in milliseconds
    const diffInMs = end.getTime() - start.getTime();

    // Convert milliseconds to days
    return Math.ceil(diffInMs / (1000 * 60 * 60 * 24)); // Use Math.ceil to round up
  }

  onBack() {
    this.location.back();
    //this.router.navigate(['/view_event']);
  }
}
